module.exports = __webpack_public_path__ + "assets/img/ef081f37640bbec97208db1defa8bdae.svg";